export default __webpack_public_path__ + "static/media/email-icon.0297acd8.svg";